import { Component, DoCheck, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { CustomElement } from '../../classes';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ColorPickerComponent),
    multi: true
};

@Component({
    selector: 'chassis-color-picker',
    templateUrl: './color-picker.component.html',
    styleUrls: ['./color-picker.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ColorPickerComponent extends CustomElement implements OnInit, DoCheck {
    @Input() placeholder = '';

    @Input() value: string = null;

    @Output() init = new EventEmitter();

    @Output() enter = new EventEmitter();

    @Output() focus = new EventEmitter();

    @Output() blur = new EventEmitter();

    @Output() keyup = new EventEmitter();

    @Output() keydown = new EventEmitter();

    @Output() paste = new EventEmitter();

    @Output() change = new EventEmitter();

    ngOnInit() {
        super.ngOnInit();
    }

    protected executeMutators() {
        super.executeMutators();
    }

    ngDoCheck() {
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/color-picker/color-picker.component.ts